export var EditingStatus;
(function (EditingStatus) {
    EditingStatus["NotStarted"] = "notStarted";
    EditingStatus["RolesHaveUnassignedFields"] = "rolesHaveUnassignedFields";
    EditingStatus["ReadyToUse"] = "readyToUse";
    EditingStatus["InUse"] = "inUse";
})(EditingStatus || (EditingStatus = {}));
//# sourceMappingURL=index.js.map